import { render, staticRenderFns } from "./modulvalidasi.vue?vue&type=template&id=6330887d&scoped=true"
import script from "./modulvalidasi.vue?vue&type=script&lang=js"
export * from "./modulvalidasi.vue?vue&type=script&lang=js"
import style0 from "./modulvalidasi.vue?vue&type=style&index=0&id=6330887d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330887d",
  null
  
)

export default component.exports